import appConfig from '@nerdwallet/app-config';
import { getLogger } from '@nerdwallet/logging';
import { getCookie } from '../cookies';

import useAnalyticsContext from './useAnalyticsContext';

const segmentTrackingLogger = getLogger('SegmentTracking');

export type MatchParams = {
  id?: string;
  slug?: string;
};

type DefaultPagePayload = {
  /* eslint-disable-next-line camelcase */
  traditional_device_id: string;
  /* eslint-disable-next-line camelcase */
  pageview_id: string;
  /* eslint-disable-next-line camelcase */
  deployable_name: string;
  /* eslint-disable-next-line camelcase */
  deployable_version: string;
};

const useAnalytics = () => {
  const { analytics } = useAnalyticsContext();

  const trackSegmentPageEvent = (
    pageName: string,
    pageViewId: string,
    matchParams: MatchParams
  ): void => {
    let name = pageName;
    // Add additional info for department and job id page names
    if (pageName === 'careers_department') {
      name += `_${matchParams.slug}`;
    } else if (pageName === 'job') {
      name += `_${parseInt(matchParams.id, 10)}`;
    }

    const defaultPayload: DefaultPagePayload = {
      traditional_device_id: getCookie('cookie_id'),
      pageview_id: pageViewId,
      // eslint-disable-next-line no-underscore-dangle
      deployable_name: appConfig?._meta?.deployable,
      // eslint-disable-next-line no-underscore-dangle
      deployable_version: appConfig?._meta?.version,
    };

    try {
      analytics.page(name, {
        ...defaultPayload,
      });
    } catch (e) {
      segmentTrackingLogger.error(e);
    }
  };

  return {
    trackSegmentPageEvent,
  };
};

export default useAnalytics;
